export default __webpack_public_path__ + "static/media/miami.1517fe3d.png";